import { useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { Group, Object3D, Object3DEventMap } from "three";
import { Context, createContext, useContext, useEffect, useState } from "react";

type ModelContextType = {
  models: Map<string, Object3D>;
};

const ModelContext: Context<ModelContextType> = createContext<ModelContextType>(
  { models: new Map<string, Object3D>() },
);

export const useModels = (): ModelContextType => useContext(ModelContext);

export const ModelProvider = ({ children }: { children: React.ReactNode }) => {
  const [models, setModels] = useState<Map<string, Object3D>>(new Map());

  // @ts-ignore
  const gltf = useLoader(GLTFLoader, import.meta.env.VITE_MODELS_PATH);

  useEffect(() => {
    if (gltf) {
      // console.log("gltf", gltf);
      const newModels = new Map<string, Object3D>();
      gltf.scene.children.forEach((child: Object3D<Object3DEventMap>) => {
        newModels.set(child.name, child as Object3D);
      });
      setModels(newModels);
    }
  }, [gltf]);

  return (
    <ModelContext.Provider value={{ models }}>{children}</ModelContext.Provider>
  );
};
